/* /assets/cart-items-mobile-toggle.js */
/* Mobile View All Products Toggle for Cart Items */

(function() {
  // Cart "View all products" toggle for mobile
  document.addEventListener('click', function(e) {
    var viewAllBtn = e.target.closest('[data-cart-view-all]');
    if (!viewAllBtn) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    var container = document.querySelector('[data-cart-items-container]');
    var textEl = viewAllBtn.querySelector('[data-cart-view-all-text]');
    
    if (!container) return;
    
    var isExpanded = container.classList.toggle('is-expanded');
    viewAllBtn.classList.toggle('is-expanded', isExpanded);
    
    // Update button text
    if (textEl) {
      var expandedText = viewAllBtn.dataset.textExpanded || 'View less';
      var collapsedText = viewAllBtn.dataset.textCollapsed || 'View all products';
      textEl.textContent = isExpanded ? expandedText : collapsedText;
    }
  });
})();
